export default __webpack_public_path__ + "static/media/error-img.950e7b0b.png";